import {
  View,
  Page,
  Document,
  Text,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import moment from "moment";

const styles = StyleSheet.create({
  body: {
    marginTop: "10px",
  },
  table: {
    display: "table",
    margin: "0px 10px",
    marginBottom: "70px",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row",
  },
  tableCol70: {
    width: "70%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol30rb: {
    width: "30%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 0,
  },
  tableCol30: {
    width: "30%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol11: {
    width: "11%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol15: {
    width: "15%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol19: {
    width: "19%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol17: {
    width: "17.5%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol17b: {
    width: "17%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol24: {
    width: "24%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol20: {
    width: "20%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol39: {
    width: "39%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol63: {
    width: "59%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol89: {
    width: "89%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol30: {
    width: "30%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },

  tableCell: {
    textAlign: "left",
    marginTop: 0,
    fontSize: 8,
    padding: "7px",
    fontWeight: 900,
  },
  tableCellCenter: {
    textAlign: "center",
    marginTop: 10,
    fontSize: 10,
    padding: "7px",
  },
  logoText: {
    textAlign: "right",
    fontSize: 14,
  },
  imageView: {
    marginLeft: "10px",
    height: "50px",
    width: "150px",
  },
});

const MyDocument = ({ leaveData }) => {
  console.log(leaveData, "leavedata");
  return (
    <Document>
      <Page style={styles.body}>
        {leaveData &&
          leaveData?.length > 0 &&
          leaveData?.map((d, i) => (
            <View style={styles.table} key={i}>
              <View style={styles.tableRow}>
                <View style={styles.tableCol70}>
                  <Text style={{ ...styles.tableCell, fontWeight: 400 }}>
                    Leave Application
                  </Text>
                </View>
                <View style={styles.tableCol30rb}>
                  <Text style={styles.tableCell}></Text>
                </View>
              </View>
              <View style={styles.tableRow}>
                <View style={styles.tableCol70}>
                  <Text style={styles.tableCell}>
                    Sanjay Josshi, 201, Ritz Square,Near Indoor Stadium, Ghod
                    dod Road Surat - 395 007
                  </Text>
                  <Text
                    style={{
                      ...styles.tableCell,
                      padding: 0,
                      marginLeft: "5px",
                    }}
                  >
                    {" "}
                    Phone: +91-9979861616, email: todros@sjosshi.com
                  </Text>
                </View>
                <View style={{ ...styles.tableCol30, borderBottomWidth: 0 }}>
                  <View
                    style={{
                      ...styles.imageView,
                      overflow: "hidden",
                    }}
                  >
                    <Image
                      style={{
                        maxHeight: "auto",
                        maxWidth: "200px",
                        objectFit: "cover",
                        display: "block",
                        margin: "0 auto",
                      }}
                      src="data:image/png;base64,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"
                    />
                  </View>
                </View>
              </View>
              <View style={styles.tableRow}>
                <View style={styles.tableCol17}>
                  <Text style={styles.tableCell}>Employee ID:</Text>
                </View>
                <View style={styles.tableCol11}>
                  <Text style={styles.tableCell}>{d.employeeId}</Text>
                </View>
                <View style={styles.tableCol17}>
                  <Text style={styles.tableCell}> Name:</Text>
                </View>
                <View style={styles.tableCol24}>
                  <Text style={styles.tableCell}>
                    {d.firstName + " " + d.lastName}
                  </Text>
                </View>
                <View style={{ ...styles.tableCol15, borderRightWidth: 0 }}>
                  {/* <Text style={styles.tableCell}>Designation</Text> */}
                </View>
                <View style={styles.tableCol15}>
                  {/* <Text style={styles.tableCell}>{d.designation}</Text> */}
                </View>
              </View>
              <View style={styles.tableRow}>
                <View style={styles.tableCol17}>
                  <Text style={styles.tableCell}>Leave Type:</Text>
                </View>
                <View style={styles.tableCol11}>
                  <Text style={{ ...styles.tableCell, fontSize: "9px" }}>
                    {d.typeOfLeave}
                  </Text>
                </View>
                <View style={styles.tableCol17}>
                  <Text style={styles.tableCell}>Designation:</Text>
                </View>
                <View style={styles.tableCol24}>
                  <Text
                    style={{
                      ...styles.tableCell,
                      fontSize: "8px",
                    }}
                  >
                    {d.designation}
                  </Text>
                </View>
                <View style={styles.tableCol15}>
                  <Text style={styles.tableCell}>No. Of Days</Text>
                </View>
                <View style={styles.tableCol15}>
                  <Text style={styles.tableCell}>{d.NoOfDays}</Text>
                </View>
              </View>
              <View style={styles.tableRow}>
                <View style={styles.tableCol11}>
                  <Text style={styles.tableCell}>Full Days:</Text>
                </View>
                <View style={styles.tableCol63}>
                  <Text style={styles.tableCell}>
                    {d.selectedDates?.map(
                      (date) => `${moment(date).format("DD/MM/YYYY")},`
                    )}
                  </Text>
                </View>
                <View style={styles.tableCol15}>
                  <Text style={styles.tableCell}>Half Days:</Text>
                </View>
                <View style={styles.tableCol15}>
                  <Text style={styles.tableCell}>
                    {d.halfDayDate &&
                      moment(d.halfDayDate).format("DD/MM/YYYY")}{" "}
                    {
                      {
                        second_half: "(S)",
                        first_half: "(F)",
                      }[d.halfDayType]
                    }
                  </Text>
                </View>
              </View>
              <View style={styles.tableRow}>
                <View style={styles.tableCol11}>
                  <Text style={styles.tableCell}>Reason:</Text>
                </View>
                <View style={styles.tableCol89}>
                  <Text style={styles.tableCell}>{d.leaveReason}</Text>
                </View>
              </View>
              <View style={styles.tableRow}>
                <View style={{ ...styles.tableCol17b, width: "16%" }}>
                  <Text
                    style={{
                      ...styles.tableCellCenter,
                      fontSize: 8,
                      textAlign: "left",
                    }}
                  >
                    Employee Signature:
                  </Text>
                </View>
                <View style={styles.tableCol19}>
                  <View style={{ ...styles.imageView, width: 80 }}>
                    {d?.applicantSignature && (
                      <Image src={d?.applicantSignature ?? ""} />
                    )}
                  </View>
                </View>
                <View style={{ ...styles.tableCol17b, width: "14%" }}>
                  <Text
                    style={{
                      ...styles.tableCellCenter,
                      fontSize: 8,
                      textAlign: "left",
                    }}
                  >
                    Senior Signature:
                  </Text>
                </View>
                <View style={{ ...styles.tableCol15, width: "14%" }}></View>
                <View style={{ ...styles.tableCol17b, width: "18%" }}>
                  <Text
                    style={{
                      ...styles.tableCellCenter,
                      fontSize: 8,
                      textAlign: "left",
                      width: 105,
                    }}
                  >
                    Management Signature:
                  </Text>
                </View>
                <View style={{ ...styles.tableCol15, width: "19%" }}></View>
              </View>
            </View>
          ))}
      </Page>
    </Document>
  );
};

export default MyDocument;
